/**
 * YouTubePlayer.tsx
 *
 * Player YouTube con IFrame API.
 * Quando il video finisce, chiama onEnded() → la pagina passa al trailer successivo.
 */

import { useEffect, useRef } from 'react';
import { loadYouTubeAPI } from '@/lib/youtube-api';

interface YouTubePlayerProps {
  videoId: string;
  title: string;
  onEnded: () => void;
}

export function YouTubePlayer({ videoId, title, onEnded }: YouTubePlayerProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const playerRef = useRef<YT.Player | null>(null);

  useEffect(() => {
    let player: YT.Player | null = null;

    loadYouTubeAPI().then(() => {
      if (!containerRef.current) return;

      player = new window.YT.Player(containerRef.current, {
        videoId,
        playerVars: {
          rel: 0,
          modestbranding: 1,
          autoplay: 0,
        },
        events: {
          onStateChange: (event: YT.OnStateChangeEvent) => {
            if (event.data === window.YT.PlayerState.ENDED) {
              onEnded();
            }
          },
        },
      });

      playerRef.current = player;
    });

    return () => {
      playerRef.current?.destroy();
      playerRef.current = null;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoId]);

  return (
    <div className="cinema-player-wrapper">
      <div ref={containerRef} title={title} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }} />
    </div>
  );
}
